import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'truncateWalletAddress',
  standalone: true,
})
export class TruncateWalletAddressPipe implements PipeTransform {
  transform(value: string | undefined, start = 8, end = 6): string {
    if (!value) {
      return '';
    }

    if (!environment.production && value.length <= start + end + 3) {
      return value;
    }

    return `${value.slice(0, start)}...${value.slice(-end)}`;
  }
}
